export default "/fonts/Acrom-Bold.ttf?ea84ffe7f7c8425ef6ceee192ec18e44";